import type { ComponentType, SVGProps } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';
import SearchIcon from '@/shared/assets/header/search.svg?react';
import WalletsIcon from '@/shared/assets/sidebar/wallets-icon.svg?react';
import TradeAccountsIcon from '@/shared/assets/sidebar/trade-accounts-icon.svg?react';
import MarketsIcon from '@/shared/assets/sidebar/markets-icon.svg?react';
import HistoryIcon from '@/shared/assets/sidebar/history-icon.svg?react';
import { SEARCH_CATEGORIES_ORDER, type SearchCategory } from '../model';

const CATEGORY_ICONS: Record<
  SearchCategory,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  all: SearchIcon,
  wallets: WalletsIcon,
  tradingAccounts: TradeAccountsIcon,
  markets: MarketsIcon,
  history: HistoryIcon,
};

type Props = {
  value: SearchCategory;
  onChange: (category: SearchCategory) => void;
};

const GlobalSearchCategories = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-[18.4rem] shrink-0 flex-col gap-px">
      {SEARCH_CATEGORIES_ORDER.map(category => {
        const Icon = CATEGORY_ICONS[category];
        const isActive = category === value;

        return (
          <button
            key={category}
            type="button"
            onClick={() => onChange(category)}
            className={cn(
              'flex items-center gap-[0.8rem] h-[3.6rem] pl-[1rem] pr-[1.2rem] rounded-[1.2rem] medium5 text-primary whitespace-nowrap cursor-pointer transition-colors hover:bg-white/8',
              isActive && 'bg-white/8'
            )}>
            <Icon className="size-[1.6rem] shrink-0" />
            {t(`personalAccount.globalSearch.categories.${category}`)}
          </button>
        );
      })}
    </div>
  );
};

export { GlobalSearchCategories };
